export default __webpack_public_path__ + "static/media/Mørklys.9f1dceaa.png";